import React from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import ContactForm from '../contact_form';
import { changeText } from '../contact_form/actions';

@connect(null, { changeText })
export default class PilotSchools extends React.Component {
  static propTypes = {
    changeText: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { changeText } = this.props;

    changeText({ name: 'subject', value: 'Pilotní školy' });
    changeText({ name: 'topic', value: 'teacher' });
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={8} mdOffset={2}>
            <div style={styles.page}>
              <h1>Pilotní školy</h1>
              <span>V nejbližších dnech se vám ozveme.</span>
            </div>
            <h2>Kontaktujte nás</h2>
            <ContactForm />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const styles = {
  page: {
    textAlign: 'center',
    marginBottom: 60
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/order/PilotSchools.jsx